import Empty from './Empty.vue';
import withInstall from '@/shared/withInstall';

export const XEmpty = withInstall(Empty);
export default XEmpty;
